import { Link } from "react-router";
import { all_routes } from "../../../../router/all_routes";

interface Props {
    activeTab: 'StorageUsage';
}

const SettingsMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
        <>
            <Link
                to={routes.storageUsage}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'StorageUsage' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Storage Usage
            </Link>
        </>
    )
}

export default SettingsMenu;

